// src/surveyjs-license.ts
import { setLicenseKey } from "survey-core";

setLicenseKey("ZDc1N2RlMmEtODlkYi00Yjc1LTk0NjktYjM4ZmFiZTY4NTI0OzE9MjAyNi0wOC0yMSwyPTIwMjYtMDgtMjEsND0yMDI2LTA4LTIx");